import React from "react";
import { useApiQuery } from "@/lib/useApiQuery";
import { useAuth } from "@/context/AuthContext";
import { EnergyRatesCard } from "@/components/EnergyRatesCard";

export default function SettingsPage() {
  const { user } = useAuth();
  const { data: health } = useApiQuery(["datasourceHealth"], "/datasource/health");
  const { data: sync } = useApiQuery(["syncStatus"], "/sync/status");

  return (
    <div className="max-w-4xl fade-up">
      <div className="k-label">System</div>
      <h1 className="mt-2 text-4xl sm:text-5xl font-bold font-display text-[#212121]">Settings</h1>

      <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="k-card p-6">
          <div className="k-label">Account</div>
          <div className="mt-3 space-y-2 text-sm">
            <div><span className="k-sublabel mr-2">Name</span><span className="text-[#212121] font-semibold">{user?.name}</span></div>
            <div><span className="k-sublabel mr-2">Email</span><span className="text-[#212121]">{user?.email}</span></div>
            <div><span className="k-sublabel mr-2">Role</span><span className="inline-flex items-center rounded-full bg-[#156F5B]/10 px-2.5 py-0.5 text-[11px] font-heading font-semibold uppercase text-[#156F5B]">{user?.role}</span></div>
          </div>
        </div>

        <div className="k-card p-6" data-testid="data-connection-status">
          <div className="k-label">Data connection</div>
          <div className="mt-3 space-y-2 text-sm">
            {health ? (
              health.ok ? (
                <>
                  <div><span className="k-sublabel mr-2">Feed</span><span className="text-[#212121]">Live time-series</span></div>
                  <div><span className="k-sublabel mr-2">Checked</span><span className="text-[#212121]">{health.checked_at ? new Date(health.checked_at).toLocaleString() : "—"}</span></div>
                  <div><span className="k-sublabel mr-2">Status</span><span className="text-[#156F5B] font-semibold">● healthy</span></div>
                </>
              ) : (
                <div className="text-red-600 text-sm">Data connection unavailable. Contact your administrator.</div>
              )
            ) : (
              <div className="k-sublabel">Loading…</div>
            )}
          </div>
        </div>

        <div className="md:col-span-2 k-card p-6" data-testid="sync-details">
          <div className="k-label">Data sync</div>
          <div className="mt-3 grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
            <div>
              <div className="k-sublabel">State</div>
              <div className={`mt-1 font-heading font-semibold ${sync?.state === "ok" ? "text-[#156F5B]" : sync?.state === "error" ? "text-red-600" : "text-amber-600"}`}>
                {sync?.state || "never"}
              </div>
            </div>
            <div>
              <div className="k-sublabel">Sites</div>
              <div className="mt-1 text-[#212121] font-semibold">{sync?.sites_synced ?? "—"}</div>
            </div>
            <div>
              <div className="k-sublabel">Points</div>
              <div className="mt-1 text-[#212121] font-semibold">{sync?.points_synced ?? "—"}</div>
            </div>
            <div>
              <div className="k-sublabel">Finished</div>
              <div className="mt-1 text-[#212121] font-semibold">{sync?.finished_at ? new Date(sync.finished_at).toLocaleString() : "—"}</div>
            </div>
          </div>
          {sync?.error && <div className="mt-4 text-red-600 text-sm">{sync.error}</div>}
          <div className="mt-6 text-xs text-[#9CA3AF]">
            Sync runs automatically every hour. Admins can trigger it manually from the header bar.
          </div>
        </div>
        <div className="md:col-span-2">
          <EnergyRatesCard isAdmin={user?.role === "admin"} />
        </div>
      </div>
    </div>
  );
}
